import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-cle-equipment-details-wrapper',
  templateUrl: './cle-equipment-details-wrapper.component.html',
  styleUrls: ['./cle-equipment-details-wrapper.component.scss'],
})
export class CleEquipmentDetailsWrapperComponent implements OnInit, OnDestroy {
  @Input() data: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
